import React, { useMemo, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import ReactDOM from 'react-dom';
import BottomToTop from "../../../../../components/transitions/bottom-to-top";
import { BlackMask } from "../../../../../components/mask";
import { Iconfont } from "../../../../../components/icon/iconfont";
import { Formik, Form, Field } from "formik";
import { BigButton } from "../../../../../components/button";
import { FormattedMessage, useIntl } from "react-intl";
import SetelctLocationPopup from "../setelct-location";
import { v4 } from "uuid";
import { fetchSetWhatsApp } from "../../../../../../api";
import Alert from "../../../../../components/alert";
import Toast from "../../../../../components/toast";


const WhatsappNumberFrom = props =>{
    const { locations, country, setSubscribe, onClose, phoneNumber } = props;
    const Intl = useIntl();
    const [currenyLocation, setCurrenyLocation] = useState(locations?.find(item=>item.value === country));

    
    const submitHandle = async (values, formikBag) =>{
        // values.email
        let response = await fetchSetWhatsApp({ phoneNumber: values.phoneNumber, phoneArea: `+${currenyLocation?.areaCode}` });
        if(response?.code === 200){
            setSubscribe(true);
            onClose();
            Toast(Intl.formatMessage({ id: "subscribe_success", defaultMessage: "Subscribe success!" }));
        }else{
            response?.result && Alert(response.result);
        }
        
        formikBag.setSubmitting(false);
    }

    const phoneId = useMemo(() =>{
        return v4();
    },[])

    return <Formik 
        onSubmit={submitHandle}
        initialValues={{
            phoneNumber: phoneNumber
        }}
        validate={(values) =>{
            const errors = {};
            const __reg_phone_normal__ = /^\d{5,20}$/;
            if (!values.phoneNumber || !__reg_phone_normal__.test(values.phoneNumber)) {
                errors.phoneNumber = Intl.formatMessage({ id: 'incorrect_phone_number', defaultMessage: 'Incorrect phone number' })
            }
            return errors;
        }} 
        enableReinitialize={true} 
    >
        {({ isSubmitting, isValid }) =>(
            <Form>
                <Field name="phoneNumber">
                    {({ field, form, meta }) => (
                        <div className={cls.InputNumberModule}>
                            <label htmlFor={phoneId}><FormattedMessage id="whatsapp_number" defaultMessage="WhatsApp Number" /></label>

                            <div className={cls.InputCnotainer}>
                                <SetelctLocationPopup 
                                    locations={locations} 
                                    onSelect={(location)=>setCurrenyLocation(location)} 
                                    currenyLocation={currenyLocation} 
                                />

                                <div className={cls.Input}>
                                    <input 
                                        id={phoneId} 
                                        className={`${meta.touched && meta.error ? cls.InputError : ""}`} 
                                        type="text" 
                                        autocomplete="off" 
                                        {...field} 
                                    />
                                </div>
                            </div>

                            {meta.touched && meta.error && <div className={cls.ErrorMsg}>{meta.error}</div>}
                        </div>
                    )}
                </Field>

                <BigButton disabled={!isValid} loading={isSubmitting} type="submit" className={cls.SubmitButton}><FormattedMessage id="confirm" defaultMessage="confirm" /></BigButton>
            </Form>
        )}
    </Formik>
}

const WhatsappNumberEditor = props =>{
    const { onClose, locations, country, setSubscribe, phoneNumber } = props;

    return <div className={cls.WhatsappNumberEditor}>
        <div className={cls.Hd}>
            <span className={cls.Font}><FormattedMessage id="enter_whatsapp_number" defaultMessage="Please enter your WhatsApp number" /></span>

            <Iconfont className={cls.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>

        <div className={cls.WhatsappNumberFrom}>   
            <WhatsappNumberFrom 
                locations={locations} 
                country={country} 
                setSubscribe={setSubscribe} 
                onClose={onClose} 
                phoneNumber={phoneNumber}
            />
        </div>
    </div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show, onClose } = props;

	return <React.Fragment>
		<BottomToTop in={show} className={cls.EditorContainer}>
			<div>
				<WhatsappNumberEditor {...props} />
			</div>
		</BottomToTop>
		{show && <BlackMask onClick={onClose} />}
	</React.Fragment>
}

export default props => {

	if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}